var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gfu-navbar-item" },
    [
      _c(
        "button",
        {
          attrs: {
            tabindex: "0",
            "aria-label": _vm.Resources.Layout.UserBoxTriggerLabel,
          },
          on: { click: _vm.onAvatarClick },
        },
        [_c("user-avatar", { attrs: { "avatar-size": 24 } })],
        1
      ),
      _vm._v(" "),
      _c(
        "drawer",
        { attrs: { "is-open": _vm.isDrawerOpen }, on: { close: _vm.onClose } },
        [
          _c(
            "drawer-header",
            { on: { close: _vm.onClose } },
            [
              _c("base-title", { attrs: { level: "h3" } }, [
                _vm._v("User Navigation"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isAuthenticated
            ? [
                _c(
                  "div",
                  { staticClass: "_px-2 _pt-3 _pb-1 _flex _gap-2" },
                  [
                    _c("user-avatar", { attrs: { "avatar-size": 48 } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _vm.isImpersonated
                          ? _c("div", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.Resources.Layout
                                      .UserBoxImpersonatingLabel
                                  ) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("base-title", { attrs: { level: "h4" } }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.userContext.user.fullName) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "_tc--light" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.userContext.user.email) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.isImpersonated
                          ? _c(
                              "div",
                              { staticClass: "_mt-1" },
                              [
                                _c("revert-impersonation-button", {
                                  attrs: {
                                    "data-qa": "user-box-button:Revert",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.groupedLinks, function (value, key) {
                  return [
                    _c(
                      "div",
                      { key: key },
                      [
                        _c("mobile-navigation-separator"),
                        _vm._v(" "),
                        _vm._l(value, function (link) {
                          return [
                            _c(
                              "div",
                              { key: link.navigationItemId },
                              [
                                _c(
                                  link.tag,
                                  {
                                    tag: "component",
                                    staticClass:
                                      "_flex _px-2 _py-1 _ai-c _gap-2 _jc-fs gfu-link-underline _cur-p",
                                    attrs: {
                                      rel: link.rel,
                                      href: link.to,
                                      target: link.target,
                                      "data-qa": `user-box-button:${link.key}`,
                                    },
                                    on: { click: link.action },
                                  },
                                  [
                                    _c("base-icon", {
                                      staticClass: "_tc--accent",
                                      attrs: {
                                        "icon-namespace": link.icon.namespace,
                                        name: link.icon.name,
                                        "is-fixed-width": "",
                                        size: "lg",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "gfu-link-underline__content",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(link.label) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    link.isTypeExternal
                                      ? _c("base-icon", {
                                          staticClass: "_tc--accent _ml-a",
                                          attrs: {
                                            name: "external-link",
                                            "is-fixed-width": "",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                }),
              ]
            : _c(
                "div",
                { staticClass: "_pa-2" },
                [
                  _c("external-login-actions", {
                    staticClass: "_mb-3",
                    attrs: { "return-url": _vm.returnUrl },
                    on: { success: _vm.onLoginSuccess },
                  }),
                  _vm._v(" "),
                  _c("login-form", {
                    attrs: { "return-url": _vm.returnUrl },
                    on: { success: _vm.onLoginSuccess },
                  }),
                ],
                1
              ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }